<template>
    <div>
<!--      :closable="false"-->
      <a-modal v-model="visibles" :width="950" title="通知" @ok="handleOk" @cancel="handleClose"  :cancel-button-props="{style:{display:'none'}}">
        <p style="font-size: 16px;line-height: 32px">各认定机构：</p>
        <p style="text-indent: 2em;font-size: 16px;line-height: 32px">
          教师资格管理信息系统计划于2024年8月22日至2024年8月24日进行设备升级维护。升级维护期间，2024年上半年教师资格认定中上传的照片和其他文件将暂时无法访问，也无法上传新的文件。系统业务后台的教师资格证书及限制库管理功能、中国教师资格网2024年上半年获得的教师资格证书查询功能、客户端文件管理功能将受影响，暂时无法查看或下载2024年上半年的照片和其他各种文件，其他功能不受影响。
        </p>
        <p style="text-indent: 2em;font-size: 16px;line-height: 32px">
          请各认定机构提前做好工作安排，下载好所需的文件资源，教师资格证书变更、删除、限制库添加等操作也请避开系统升级维护时间，以免影响工作开展。
       </p>
        <p style="text-indent: 2em;font-size: 16px;line-height: 32px"> 感谢对我中心工作的理解和支持！</p>
        <p style="text-align: right;">教育部教师资格认定指导中心</p>
        <p style="text-align: right;">2024年8月2日</p>
      </a-modal>
    </div>
</template>

<script>
export default {
  name: "AlertMessage",
  data() {
    return {
      visibles:false
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch:{
    visible: {
      handler: function(val) {
        this.visibles = val;
      },
      deep: true,
      immediate:true
    }
  },


  methods: {
    handleClose(){
      this.$emit("handleClose",false)
    },
    handleOk() {
      this.$emit("handleOk",false)
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AlertMessage.vue